import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Observable, switchMap, take } from 'rxjs';
import { QcropFacade } from '../state/facades/qcrop.facade';

@Injectable({
  providedIn: 'root',
})
export class TokenInterceptor implements HttpInterceptor {
  constructor(private qcropFacade: QcropFacade) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (req.url.toLowerCase().includes('/api/qcrop')) {
      return this.qcropFacade.token$.pipe(
        take(1),
        switchMap(token => {
          if (token) {
            const cloned = req.clone({
              setHeaders: {
                'x-token': `${token}`,
              },
            });
            return next.handle(cloned);
          }
          return next.handle(req);
        })
      );
    }
    return next.handle(req);
  }
}
